import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="py-12 px-4" data-id="element-119">
      <div className="max-w-4xl mx-auto" data-id="element-120">
        <FadeIn data-id="element-121">
          <div className="glass-card rounded-2xl p-6 md:p-8 relative overflow-hidden" data-id="element-122">
            {/* Subtle left border accent */}
            <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-gradient-to-b from-gold-400 to-gold-500/20" data-id="element-123" />

            <h2 className="text-2xl md:text-3xl font-heading font-bold text-gold-400 mb-5" data-id="element-124">
              Después de los 50, tu cuerpo cambia las reglas del juego.
            </h2>

            <div className="space-y-4 text-lg text-warmWhite-200 leading-relaxed" data-id="element-125">
              <p data-id="element-126">
                La caída de estrógenos desconfigura tu termostato interno y tu
                capacidad de producir melatonina. Por eso, los consejos típicos
                de "bebe un té de manzanilla" simplemente no funcionan para ti.
              </p>
              <p data-id="element-127">
                Has intentado pastillas que te dejan con{' '}
                <span className="text-warmWhite-100 font-medium" data-id="element-128">
                  "resaca química"
                </span>
                , has probado a apagar el televisor, pero el silencio solo hace
                que tus pensamientos griten más fuerte.
              </p>
              <p className="text-xl font-heading italic text-gold-400/90 pt-2" data-id="element-129">
                El problema no eres tú, es que estás usando herramientas de
                cuando tenías 20 años para un cuerpo que hoy necesita una
                estrategia diferente.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}